<div (click)="this.main?.linkBlank(this.generateUrl())" [class.cardAgente__borderCard]="this.isDetailAgencyPage==true"
    class="cardAgente cursor-pointer">
    <div class="cardAgente__top d-flex cursor-pointer">

        <div id="test" class="roundedImage image-lazy">
            <img width="50" height="50" alt="cover card agente" class="roundedImage"
                [class.roundedImage--agentPlaceholder]="!this.agentObj?.member?.profile_img"
                ngSrc="{{this.main.generatePictureUrl(this.agentObj?.member?.profile_img, '80', 'agent')}}" />
        </div>

        <div class="ratingAndName ps-2">
            <div class="nameAndRole">
                <div class="d-flex align-items-center">
                    <h4 class="p-0 m-0 text-uppercase name textOneLine fw-600">{{this.agentObj?.member?.first_name}}
                        {{this.agentObj?.member?.last_name}}</h4>
                    <app-badge *ngIf="this.agentObj?.isTop" [addMarginLeft]="true"
                        [badgeType]="this.agentObj?.isTop ? 'agente-top' : ''"></app-badge>
                </div>
                <div class="d-flex">
                    <ng-container
                        *ngIf="this.agentObj?.agency_role==='' || !this.agentObj?.agency_role; else showAgentRole">
                        <p class="mb-0">Agente, {{this.agencyObj?.name | titlecase}}</p>
                    </ng-container>
                    <ng-template #showAgentRole>
                        <p class="mb-0 me-1">{{this.agentObj?.agency_role}}, {{this.agencyObj?.name | titlecase}}</p>
                    </ng-template>
                </div>
            </div>

            <div class="agentAddress d-flex align-items-baseline">
                <i class="icon-map-marker-alt me-1"></i>
                <p>{{this.agentObj?.address | titlecase}} <span>- {{this.agentObj?.city | titlecase}}</span></p>
            </div>

            <div class="d-flex align-items-center justify-content-start mt-1">
                <div class="agentRating d-flex align-items-center">
                    <i [class.starNoReview]="this.agentObj?.number_reviews == 0" class="icon-star"></i>
                    <p *ngIf="this.agentObj?.average_stars && this.agentObj?.average_stars >= 0"
                        class="mb-0 ms-1 fw-normal">{{this.agentObj?.average_stars.toPrecision(2)}}</p>
                    <p *ngIf="!this.agentObj?.average_stars" class="mb-0 ms-1 fw-normal">0</p>
                    <p class="mb-0 ms-1 fw-normal">({{this.agentObj?.number_reviews}})</p>
                </div>

                <div class="starCont m-0 ms-2" (click)="$event.stopPropagation(); this.handleFavouriteAgent()">
                    <i class="me-1" [class.icon-heart]="this.main?.savedAgent(this.agentObj?.id)"
                        [class.icon-heart-saved]="!this.main?.savedAgent(this.agentObj?.id)"></i>
                    {{this.agentObj?.numberOfFavourites}}
                </div>
                <div class="starCont starCont--likes m-0 ms-2"
                    (click)="$event.stopPropagation(); this.handleLikesagent()">
                    <i class="me-1 " [class.colorPrimary]="!this.main?.checkLikedAgent(this.agentObj?.id)"
                        [class.icon-thumbs-up]="this.main?.checkLikedAgent(this.agentObj?.id)"
                        [class.icon-thumbs-up-liked]="!this.main?.checkLikedAgent(this.agentObj?.id)"></i>
                    {{this.agentObj?.likes}}
                </div>
            </div>

        </div>
    </div>
    <div class="cardAgente__middle">
        <div class="cardAgente__middle__agentData">
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 orangeColor">{{this.countForSale()}}</p>
                <p class="mb-0 fw-600">Vendita</p>
            </div>
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 orangeColor">{{this.countOnRent()}}</p>
                <p class="mb-0 fw-600">Affitto</p>
            </div>
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 greenColor">{{this.countSold()}}</p>
                <p class="mb-0 fw-600">Vendute</p>
            </div>
            <div class="cardAgente__middle__agentData__item">
                <p class="mb-0 fw-600 greenColor">{{this.countRented()}}</p>
                <p class="mb-0 fw-600">Affittate</p>
            </div>
        </div>
        <div class="cardAgente__middle__agentZones d-flex">
            <ng-container *ngIf="this.agentObj?.zones_served?.length > 0">
                <div class="d-flex zoneServedCont">
                    <ng-container *ngFor="let zone of this.agentObj?.zones_served; let i=index">
                        <ng-container *ngIf="i<2">
                            <div class="singleZone d-flex me-2 align-items-center justify-content-center">
                                <i class="icon-map-marker-alt me-1"></i>
                                <p class="mb-0">{{zone.display_name}}</p>
                            </div>
                        </ng-container>
                    </ng-container>
                    <div *ngIf="this.agentObj?.zones_served.length > 2"
                        class="singleZone d-flex me-1 align-items-center justify-content-center px-2">
                        <p class="mb-0">+{{this.agentObj?.zones_served.length-2}}</p>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="cardAgente__namingList d-flex align-items-center">
        <ng-container *ngIf="this.countAgentSkills()">
            <div class="specContainer">
                {{this.orderAgentSkills().skills.join(' - ')}}
            </div>
        </ng-container>
    </div>

    <div class="cardAgente__namingList d-flex">
        <ng-container *ngIf="this.agentObj?.specialization?.length > 0">
            <div class="specContainer">
                {{this.agentObj?.specialization?.join(', ')}}
            </div>
        </ng-container>
    </div>

    <div class="cardAgente__logosRow d-flex pb-0 pt-1">
        <div class="whuisCertificato-wrapper">
            <ng-container *ngIf="this.agentObj?.verified==='whuis'">
                <div class="logoWhuis me-3"></div>
            </ng-container>
        </div>
        <ng-container *ngIf="this.agentObj?.status === 'available' && (
            this.agentObj?.fiaip_associate ||
            (this.agentObj?.association && this.agentObj?.association==='fiaip') ||
            (this.agentObj?.association && this.agentObj?.association==='fimaa') ||
            (this.agentObj?.association && this.agentObj?.association==='air') ||
            (this.agentObj?.association && this.agentObj?.association==='oam') ||
            (this.agentObj?.association && this.agentObj?.association==='ance') ||
            (this.agentObj?.association && this.agentObj?.association==='anama')
        ); else agencyAssociation">
            <ng-container
                *ngIf="(this.agentObj?.fiaip_associate || (this.agentObj?.association && this.agentObj?.association==='fiaip'))">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/fiaip_logo_sm.png" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container *ngIf="this.agentObj?.association && this.agentObj?.association==='fimaa'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/fimaa.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container *ngIf="this.agentObj?.association && this.agentObj?.association==='air'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/air.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container *ngIf="this.agentObj?.association && this.agentObj?.association==='oam'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/oam.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container *ngIf="this.agentObj?.association && this.agentObj?.association==='ance'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/ance.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container *ngIf="this.agentObj?.association && this.agentObj?.association==='anama'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/anama.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
        </ng-container>
        <ng-template #agencyAssociation>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && (this.agencyObj?.fiaip_associate || (this.agencyObj?.association && this.agencyObj?.association==='fiaip'))">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/fiaip_logo_sm.png" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && this.agencyObj?.association && this.agencyObj?.association==='fimaa'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/fimaa.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && this.agencyObj?.association && this.agencyObj?.association==='air'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/air.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && this.agencyObj?.association && this.agencyObj?.association==='oam'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/oam.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && this.agencyObj?.association && this.agencyObj?.association==='ance'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/ance.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
            <ng-container
                *ngIf="this.agentObj?.status === 'available' && this.agencyObj?.association && this.agencyObj?.association==='anama'">
                <div class="logoFiap me-2">
                    <img ngSrc="../../../../assets/img/loghi_associations/anama.jpg" fill alt="logo fiap">
                </div>
            </ng-container>
        </ng-template>

        <img [style.width]="0" [style.height]="0" loading="lazy"
            src="{{this.main.generatePictureUrl(this.agencyObj?.logo_img, '100', 'agency')}}"
            (error)="this.imgLogoError = true" alt="">
        <div class="logoFiap ms-2">
            <img *ngIf="this.agencyObj?.logo_img && !this.imgLogoError" alt="Logo agenzia"
                ngSrc="{{this.main.generatePictureUrl(this.agencyObj?.logo_img, '100', 'agency')}}" fill>
        </div>

    </div>
</div>